import * as React from "react";

import { EntitetModellComponent } from "../Component/EntitetModellComponent"
import { alleHandlinger } from "../Component/Handlinger"
import { FakturaPoliseTabell } from "../Faktura/FakturaPoliseTabell";
import { visSomPdf, inlineFelt, inlineFeltMedBeskrivelse, beskrivelseGui, errors, hentFeltVerdi, finnFelt } from "../Component/felt"
import { ILoaderProps } from "../domene"

import Models = Gf.Web.Models;
import { appContext } from "../App/appContext";

export class Faktura extends EntitetModellComponent<Models.FakturaFeltType, Models.FakturaModell> {
    constructor(props: ILoaderProps) { super(props, "Faktura"); }

    clientAction(handling: Models.HandlingType) {
        if (handling === Models.HandlingType.Faktura_Pdf) {
            visSomPdf();
            return true;
        }
        return false;
    }

    renderWithModel(model: Models.FakturaModell | undefined) {
        const fakturaFelt = (feltType: Models.FakturaFeltType) => inlineFelt(model, this.getHandler(), feltType);
        const feltMedBeskrivelse = (feltType: Models.FakturaFeltType) => inlineFeltMedBeskrivelse(model, this.getHandler(), feltType);
        const fakturaNr = hentFeltVerdi(finnFelt(model, Models.FakturaFeltType.FakturaNr)) as number | undefined;
        const pdf = appContext.visning === "pdf";
        const innmat = <div className="fakturaHode">
                           {alleHandlinger(model, this.getHandler(), handling => this.clientAction(handling))}
                           {errors(this.getHandler())}
                           {(pdf && (!fakturaNr)) ? null : feltMedBeskrivelse(Models.FakturaFeltType.FakturaNr) }
                           {feltMedBeskrivelse(Models.FakturaFeltType.MottakerNavn) }
                           {beskrivelseGui("Periode", <span className="periode">{fakturaFelt(Models.FakturaFeltType.FraDato) } - {fakturaFelt(Models.FakturaFeltType.TilDato) }</span>)}
                           {feltMedBeskrivelse(Models.FakturaFeltType.SumBrutto) }
                           {feltMedBeskrivelse(Models.FakturaFeltType.SumProvisjon) }
                           {feltMedBeskrivelse(Models.FakturaFeltType.SumNetto) }
                       </div>;
        return <FakturaPoliseTabell params={this.props.params} laster={this.laster}>{innmat}</FakturaPoliseTabell>;
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Faktura/Faktura.tsx